// extracted by mini-css-extract-plugin
module.exports = {"graph":"Graph-module__graph___2S2Tt"};